import { createSlice } from "@reduxjs/toolkit";
import { getMotorsList } from "../../reduxApi/admin/MotorizationReduxApi";

const motorSlice = createSlice({
    name: 'motor',
    initialState: {
        status: 'idel',
        isFiltered: false,
        motor: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteMotorAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.motor.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.motor.splice(index, 1);
                }
            });
        },
        updateMotorAction: (state, action) => {
            const index = state.motor.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.motor.splice(index, 1, { motors: action.payload })
            }
        },
        addMotorAction: (state, action) => {
            console.log("action--->",action.payload);
            
            const temp = action.payload;
            console.log("temp",temp)
            temp.ROWID = action.payload.ROWID;
            console.log("temp.ROWID",temp.ROWID);
            
            state.motor.unshift({ motors: temp }); //add new data at beginning of array 
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getMotorsList.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getMotorsList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.motor = action.payload.data.motors;
            })
    }
})
export const { deleteMotorAction, updateMotorAction, addMotorAction, setFilteredStatus } = motorSlice.actions
export default motorSlice.reducer